// extracted by mini-css-extract-plugin
export default {"statusButtonsContainer":"styles_statusButtonsContainer__Yj2GZ","vr":"styles_vr__LhuxI"};